<template>
  <LoadingSpinner v-if="loadingPage" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-6"><h6>Usuarios</h6></div>
              <div class="col-md-6 text-end">
                <button
                  class="btn bg-gradient-primary btn-xs"
                  @click="openModal"
                >
                  <i class="ri-add-line me-1"></i>
                  Nuevo usuario
                </button>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 vh-50">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Usuario
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Correo/Usuario
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Estatus
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="usuario in usuarios.data" :key="usuario.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <img
                            src="https://img.freepik.com/free-icon/team_318-411397.jpg"
                            class="avatar avatar-sm me-3"
                            alt="user6"
                          />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm text-lowercase">
                            {{ usuario.nombre }} {{ usuario.paterno }}
                            {{ usuario.materno }}
                          </h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ usuario.correo }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle">
                      <span class="text-secondary text-xs font-weight-bold">
                        <h6 class="mb-0 text-sm text-lowercase">
                          {{ usuario.empresa }}
                        </h6>
                        <p class="text-xs text-lowercase text-secondary mb-0">
                          {{ usuario.email }}
                        </p>
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        v-if="usuario.activo"
                        class="badge badge-sm bg-gradient-success"
                        >Activo</span
                      >
                      <span v-else class="badge badge-sm bg-gradient-danger"
                        >Inactivo</span
                      >
                    </td>
                    <td class="align-middle text-center">
                      <button
                        class="btn btn-link text-xs text-secondary p-0 m-0"
                        @click="showModalUsuario(usuario)"
                        :disabled="loadingBtnEdit"
                      >
                        <span
                          v-if="loadingBtnEdit"
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <i
                          class="ri-pencil-line me-1"
                          v-if="!loadingBtnEdit"
                        ></i>
                        Modificar
                      </button>
                      |
                      <button
                        class="btn btn-link text-xs text-secondary p-0 m-0"
                        @click="openModalPassword(usuario)"
                      >
                        <i class="ri-key-2-line me-1"></i>
                        Contraseña
                      </button>
                      |
                      <button
                        class="btn btn-link text-xs text-secondary p-0 m-0"
                        @click="updateEstatus(usuario.activo, usuario.id)"
                      >
                        <i class="ri-shut-down-line me-1"></i>
                        {{ textoActivacion(usuario.activo) }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 px-4">
                <PaginationComponent
                  :current-page="usuarios.current_page"
                  :last-page="usuarios.last_page"
                  @page-change="fetchUsuarios"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">
            {{ modalTitle }}
          </h1>
          <button
            ref="Close"
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <form method="POST" id="formUsuario" @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 mb-2">
                <label for="nombre">Nombre*:</label>
                <input
                  v-model="nombre"
                  type="text"
                  class="form-control"
                  name="nombre"
                  id="nombre"
                  required
                  autocomplete="off"
                />
              </div>
              <div class="col-md-12 mb-2">
                <label for="paterno">Apellido paterno*:</label>
                <input
                  v-model="paterno"
                  type="text"
                  class="form-control"
                  name="paterno"
                  id="paterno"
                  required
                  autocomplete="off"
                />
              </div>
              <div class="col-md-12 mb-2">
                <label for="materno">Apellido materno:</label>
                <input
                  v-model="materno"
                  type="text"
                  class="form-control"
                  name="materno"
                  id="materno"
                  autocomplete="off"
                />
              </div>
              <div class="col-md-12 mb-2">
                <label for="correo">Correo electrónico*:</label>
                <input
                  v-model="correo"
                  type="text"
                  class="form-control"
                  name="correo"
                  id="correo"
                  required
                  autocomplete="off"
                />
              </div>
              <div class="col-md-12 mb-2" v-if="showSectionPassword">
                <label for="contrasena">Contraseña*:</label>
                <div class="position-relative">
                  <input
                    v-model="contrasena"
                    :type="passwordType"
                    class="form-control"
                    name="contrasena"
                    id="contrasena"
                    required
                    autocomplete="off"
                  />
                  <i
                    :class="iconPassword"
                    class="position-absolute end-0 top-0 mt-2 me-3"
                    @click="togglePassword"
                  ></i>
                </div>
              </div>
              <div class="col-md-12 mb-2">
                <label for="rol">Rol*:</label>
                <select
                  name="rol"
                  id="rol"
                  class="form-control"
                  required
                  v-model="rol"
                >
                  <option value="">Seleccione</option>
                  <option :value="rol.id" v-for="rol in roles" :key="rol.id">
                    {{ rol.nombre }}
                  </option>
                </select>
              </div>
              <div class="col-md-12 mb-2">
                <label>Arrendamientos*</label>
                <multiselect
                  v-model="value"
                  :options="options"
                  :value="[options]"
                  :searchable="true"
                  :multiple="true"
                  label="nombre"
                  track-by="id"
                  required
                  placeholder="Seleccione"
                  :object="true"
                ></multiselect>
              </div>
              <div class="col-md-12">
                <label>Líder comercial (opcional)</label>
                <multiselect
                  v-model="lider_id"
                  :options="listaUsuarios"
                  :value="[listaUsuarios]"
                  :searchable="true"
                  :multiple="false"
                  label="nombreMostrar"
                  track-by="id"
                  required
                  placeholder="Seleccione"
                  :object="false"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="loadingBtn"
            >
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
                v-show="loadingBtn"
              ></span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="modalPassword"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">
            Reestablecer contraseña
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="Close"
          ></button>
        </div>
        <form
          method="POST"
          @submit.prevent="updateUserPassword"
          id="formPassword"
        >
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 mb-2 form-group">
                <label for="password">Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="password"
                  name="password"
                  id="password"
                  required
                />
              </div>
              <div class="col-md-12 mb-2 form-group">
                <label for="confirm_password">Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="confirm_password"
                  name="confirm_password"
                  id="confirm_password"
                  required
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary">
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
                v-show="loadingBtn"
              ></span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import useUsuario from "@/composables/useUsuario";
import LoadingSpinner from "@/components/LoadingComponent.vue";
import PaginationComponent from "@/components/PaginationComponent";
import Multiselect from "vue-multiselect";

export default {
  name: "usuarios",
  components: {
    LoadingSpinner,
    PaginationComponent,
    Multiselect,
  },
  setup() {
    const {
      usuarios,
      loadingPage,
      value,
      options,
      roles,
      passwordType,
      modalTitle,
      loadingBtn,
      togglePassword,
      fetchRolesUsuario,
      fetchArrendamientoTipos,
      fetchUsuarios,
      updateEstatus,
      textoActivacion,
      iconPassword,
      showModalUsuario,
      nombre,
      paterno,
      materno,
      correo,
      contrasena,
      rol,
      showSectionPassword,
      closeModal,
      Close,
      usuario_id,
      openModal,
      arrendamientosByUser,
      submitForm,
      openModalPassword,
      password,
      confirm_password,
      updateUserPassword,
      loadingBtnEdit,
      listaUsuarios,
      lider_id,
    } = useUsuario();

    fetchRolesUsuario();
    fetchArrendamientoTipos();
    fetchUsuarios();

    return {
      usuarios,
      loadingPage,
      value,
      options,
      roles,
      passwordType,
      modalTitle,
      loadingBtn,
      togglePassword,
      fetchRolesUsuario,
      fetchArrendamientoTipos,
      fetchUsuarios,
      updateEstatus,
      textoActivacion,
      iconPassword,
      showModalUsuario,
      nombre,
      paterno,
      materno,
      correo,
      contrasena,
      rol,
      showSectionPassword,
      closeModal,
      Close,
      usuario_id,
      openModal,
      arrendamientosByUser,
      submitForm,
      openModalPassword,
      password,
      confirm_password,
      updateUserPassword,
      loadingBtnEdit,
      listaUsuarios,
      lider_id,
    };
  },
};
</script>
<style>
@media (max-width: 767px) {
  .table-responsive .dropdown-menu {
    position: static !important;
  }
}
@media (min-width: 768px) {
  .table-responsive {
    overflow: hidden;
  }
}
</style>
